import { Navigate } from "react-router-dom";
import { isTokenValid } from "../utils/auth.js";

const getToken = () => localStorage.getItem("auth_token");

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  if (!isTokenValid(token)) {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_name");
    localStorage.removeItem("auth_email");
    return <Navigate to="/app" replace />;
  }
  return children;
};

export const GuestRoute = ({ children }) => {
  const token = getToken();
  if (isTokenValid(token)) return <Navigate to="/home" replace />;
  return children;
};

export default ProtectedRoute;
